<template>
<div>
    <div class="row">
        <div class="col-lg-6">
            <card v-if="grants.length" v-for="grant in grants" v-bind:key="grant.grantId">
                <template slot="header">
                    <h3 class="card-title">{{ grant.description }}</h3>
                </template>
                <div class="form-group" v-if="regions[grant.grantId].length != 0">
                    <label for="regionSelect">{{$t('medium_grant.technical__1_region')}}</label> 
                        <select class="form-control region-select"
                            name="technical.region"
                            v-model="selectedRegion[grant.grantId]"
                            id="regionSelect"
                            v-validate="'required'"
                            :data-vv-as="$t('medium_grant.technical__1_region')"
                            >
                            <option value="" selected="selected">{{$t('medium_grant.general__please_select')}}</option>
                            <option :value="region" v-for="region in regions[grant.grantId]" :key="region.regionId">{{region.code}} - {{region.name}}</option>
                            
                        </select>
                </div>
                <div>
                    <base-button
                        v-if="(!grant.applied && grant.locked) || regions[grant.grantId].length == 0"
                        disabled
                        type="primary"
                        size="lg"
                        simple
                        >
                        {{ $t('grants.proposals_closed') }}
                    </base-button>
                    <base-button
                        v-else-if="!grant.locked && (grant.applicationsPerUser < 0 || grant.applicationsCount < grant.applicationsPerUser && selectedRegion[grant.grantId])"
                        @click="applyFor(grant.grantId,selectedRegion[grant.grantId].regionId,selectedRegion[grant.grantId].budget)"
                        type="primary"
                        size="lg"
                        simple
                        >
                        {{ $t('grants.apply') }}
                    </base-button>
                    <base-button
                        v-else-if="!selectedRegion[grant.grantId]"
                        disabled
                        type="primary"
                        size="lg"
                        simple
                        >
                        {{ $t('grants.apply') }}
                    </base-button>
                    <base-button
                        v-else="grant.applied"
                        disabled
                        type="primary"
                        size="lg"
                        simple
                        >
                        {{ $t('grants.already_applied') }}
                    </base-button>
                </div>
            </card>

            <card v-if="initialized && !grants.length">
                <h3 class="card-title">
                    {{ $t('grants.empty_state') }}
                </h3>
            </card>
        </div>
    </div>
</div>
</template>
<script>
import {
    GrantService
} from '@/services';

export default
{
    data()
    {
        return {
            initialized: false,
            selectedRegion: [],
            grants: [],
            regions:[],
        };
    },
    methods:
    {
        /*applyFor(grantId)
        {
            this.$router.push('/application/fill/' + grantId);
            
        },*/
        applyFor(grantId,regionId,budgetPercentage)
        {
            //this.$router.push('/application/fill/' + grantId + '/' + regionId + '/' + budgetPercentage);
            this.$router.push({
            name: "NewFill",
            params: { grantId: grantId, regionId: regionId, appversion: 1 },
            });
            
        },

        async getList()
        {
            let loader = this.$loading.show();

            GrantService.all().then((response) =>
            {
                this.grants = response.data;
                this.initialized = true;
                loader.hide();
            });

            GrantService.getGrantRegions().then((response) =>
            {
                this.regions = response.data.data;
                loader.hide();
            });
        }
    },
    created()
    {
        this.getList();
    }
};
</script>
<style lang="scss">
.region-select{
    max-width: 200px !important;
}
</style>
